import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import NavBar from "./NavBar"
import RouterApp from "./RouterApp"
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { HashRouter } from "react-router-dom";
import '@mantine/core/styles.css';
import { createTheme, MantineProvider } from '@mantine/core';




const theme = createTheme({
  /** Put your mantine theme override here https://mantine.dev/getting-started/#can-i-use-mantine-with-create-react-app*/
  fontFamily: 'Open Sans, sans-serif',
  primaryColor: 'cyan',
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode style={{height: "100%"}}>
    <MantineProvider theme={theme}>
      <HashRouter>
    <NavBar />
    <RouterApp />
      </HashRouter>
    </MantineProvider>
  </React.StrictMode>
);

